import Cookies from 'js-cookie'

const TokenKey = 'yuer-token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRefreshToken() {
  return Cookies.get('yuer-refresh-token')
}

export function setRefreshToken(token) {
  return Cookies.set('yuer-refresh-token', token)
}

export function removeRefreshToken() {
  return Cookies.remove('yuer-refresh-token')
}
